import { useQueryClient, useMutation } from '@tanstack/react-query';
import { fetcher } from '../utils';
import { ITEM, ADMIN_ITEMS_ALL, ADMIN_ITEM_DELETE } from '../queryKeys';

export const useAdminDeleteItem = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (itemId: string): Promise<void> => {
    const response = await fetcher(`/v2/admin/items/${itemId}`, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });

    if (response.status !== 204)
      throw new Error((await response.json()).error ?? 'Did not work!');

    queryClient.invalidateQueries({ queryKey: ADMIN_ITEMS_ALL });
    queryClient.invalidateQueries({ queryKey: ITEM, exact: false });
  };

  const { mutate, error, status, isPending, isSuccess, isError } = useMutation({
    mutationKey: ADMIN_ITEM_DELETE,
    mutationFn,
  });

  return { mutate, error, status, isPending, isSuccess, isError };
};
